import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import SrFormikField from 'client/components/SrFormikField';
import { withErrorReporter } from 'client/helpers/formikHelpers';
import postWithState from 'client/actions/postWithState';

import { SR_API_ACTION_HOUSEHOLD_ASSIGN_ADMIN_USER_ID } from 'api/actionTypes';

const SrAssignHouseholdAdminSelect = ({
  householdId,
  assignedAdminUserId,
  reloadDataTable,
  householdAdminsList,
  dispatch,
}) => (
  <Formik
    enableReinitialize
    initialValues={{
      assignedAdminUserId: assignedAdminUserId || '',
    }}
    render={(formikBag) => (
      <SrFormikField
        formikBag={formikBag}
        formField={{
          type: 'select',
          id: 'assignedAdminUserId',
          properties: {
            placeholder: 'Choose a CSR...',
            choices: [
              {
                label: 'Unassigned',
                value: '',
              },
            ].concat(
              householdAdminsList.map(({ id, name }) => ({
                label: name,
                value: id,
              })),
            ),
            onChange: withErrorReporter(async (e) => {
              const adminUserId = parseInt(e.target.value, 10) || null;
              await dispatch(postWithState, {
                action: SR_API_ACTION_HOUSEHOLD_ASSIGN_ADMIN_USER_ID,
                payload: {
                  householdId,
                  adminUserId,
                },
              });
              await reloadDataTable();
            }),
          },
        }}
      />
    )}
  />
);

SrAssignHouseholdAdminSelect.propTypes = {
  householdId: PropTypes.number.isRequired,
  assignedAdminUserId: PropTypes.number,
  reloadDataTable: PropTypes.func.isRequired,
  householdAdminsList: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
};

SrAssignHouseholdAdminSelect.displayName = 'SrAssignHouseholdAdminSelect';

export default SrAssignHouseholdAdminSelect;
